<template>
  <div class="form-checkbox _mb-2">
    <input type="checkbox" class="hot-form__input custom-checkbox" v-bind="{ id, name, disabled, required, value }" @change.stop="toggleCheck" :checked="isSelected">

    <label class="hot-form__label _mb-0 _ml-2" :for="id" v-if="hasSlot">
      <slot></slot>
    </label>
  </div>
</template>

 <script>
  import FormInputEmit from '../FormInputEmit'

  export default {
    name: 'form-checkbox',
    mixins: [
      FormInputEmit
    ]
  }
</script>

<style lang="scss" scoped>
  @import '~stylesheets/meta.scss';

  $input-sides: 20px;

  .form-checkbox {
    display: flex;
    min-height: $input-sides;
    min-width: $input-sides;
    align-items: center;
  }

  .custom-checkbox {
    cursor: pointer;
    height: 16px;
    width: 16px;
  }
</style>
